/**
 * 需要調達計画詳細画面の表示モード（procurement-plan-detail-filter 設計書、
 * design `plan/submission-detail.html` `#sd-view-seg` 準拠）:
 * - `perCounterpartyTotal`: 取引先毎合計（同一取引先の複数契約列を合算表示。既定）
 * - `perTransaction`: 取引毎（取引先の各契約列をそのまま表示）
 *
 * 選択 UI (DetailFilterBar) と列表示切替 (PlanTable) の両方が参照するため、
 * どちらのコンポーネントにも属さない共有の場所に型を置く。
 */
export type DisplayMode = 'perTransaction' | 'perCounterpartyTotal'

/** 表示モードの既定値 (design #sd-view-seg の checked 項目に一致)。 */
export const DEFAULT_DISPLAY_MODE: DisplayMode = 'perCounterpartyTotal'
